import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as formsAction from "../../../redux/actions/formsAction";
import { OverlayTrigger, Popover } from 'react-bootstrap';

function mapStateToProps(state) {
    return {
        data: state.formDataReducer,
        filterdata: state.formDataReducer.filterdata,
        token: state.formLoginReducer.token,
        hasErrored: state.formDataReducer.hasErrored,
        isLoading: state.formDataReducer.isLoading,
    };
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(formsAction.updateData(key, value, storekey)),
    }
}
class Facet extends Component {
    constructor() {
        super();
        this.state = {
            hide: {},
            selectedFacets: {},
            searchFacet: {}
        };
    }
    toggle(key) {
        var { hide } = this.state;
        hide[key] = !hide[key];
        this.setState({
            hide: hide
        });
    }
    onSelectionsChange(event, key, value, ctr) {
        var { selectedFacets } = this.state;

        try {
            var type = this.facetType(key);
            if (this.facetOperator(key) == 'range') {
                let Item = selectedFacets[key] ? selectedFacets[key] : {};
                if (ctr == 'min') {
                    Item.min = type == 'string' ? event : parseInt(event);
                } else if (ctr == 'max') {
                    Item.max = type == 'string' ? event : parseInt(event);
                }
                selectedFacets[key] = Item;
            } else {
                let Items = selectedFacets[key] ? selectedFacets[key] : [];
                if (event) {
                    Items.push(type == 'string' ? value : parseInt(value));
                } else {
                    Items = Items.filter(x => x != value)
                }
                selectedFacets[key] = Items;

                this.props.search(selectedFacets);
            }
        } catch (e) {
            console.log(e)
        }
        this.setState({ selectedFacets: selectedFacets });
    }
    getPacehoder(key) {
        const { control } = this.props;
        var placeholder = "";
        if (Array.isArray(control.facet)) {
            var item = control.facet.find(x => x.key == key);
            placeholder = item && item.placeholder ? item.placeholder : "";
        }
        return placeholder;
    }
    getTitle(key) {
        const { control } = this.props;
        var title = key;
        if (Array.isArray(control.facet)) {
            var item = control.facet.find(x => x.key == key);
            title = item && item.title ? item.title : key;
        }
        return title;
    }
    facetType(key) {
        const { control } = this.props;
        var type = "string";
        if (Array.isArray(control.facet)) {
            var item = control.facet.find(x => x.key == key);
            type = item && item.type ? item.type : "string";
        }
        return type;
    }
    facetOperator(key) {
        const { control } = this.props;
        var operator = "in";
        if (Array.isArray(control.facet)) {
            var item = control.facet.find(x => x.key == key);
            operator = item && item.operator ? item.operator : "in";
        }
        return operator;
    }
    setSearchFacet(value, key) {
        var { searchFacet } = this.state;
        searchFacet[key] = value;

        this.setState({ searchFacet: searchFacet });
    }
    getMinMax(key, facetData, type) {
        const { control } = this.props;
        var data = [];
        if (Array.isArray(facetData)) {
            facetData.map(x => data.push(x.value));
        }
        var value = Array.isArray(data) ? type == 'min' ? Math.min.apply(null, data) : Math.max.apply(null, data) : null;
        if (Array.isArray(control.facet)) {
            var item = control.facet.find(x => x.key == key);
            if (type == 'min') {
                value = item && item.value && item.value.min ? item.value.min : value;
            } else {
                value = item && item.value && item.value.max ? item.value.max : value;
            }
        }
        return value;
    }
    render() {
        const { facetData, control } = this.props;
        const { selectedFacets, searchFacet } = this.state;

        const keys = facetData ? Object.keys(facetData) : [];

        return (
            <div className='bg-light pt-2 mb-3'>
                {control.facetPosition == 'top' ?
                    <div className="d-flex facetsDropdownOuter">
                        {keys.map(key => {
                            return (
                                
                                    this.facetOperator(key) == 'range' ?
                                        <div className="mb-2 ml-3 d-flex">
                                            <span className="align-self-center pr-2">{this.getTitle(key)}</span>
                                            <div style={{maxWidth:80}}>
                                                <input
                                                    aria-label="Min"
                                                    className="form-control"
                                                    type="number"
                                                    min="0"
                                                    placeholder="Min"
                                                    value={selectedFacets[key] && selectedFacets[key].value ? selectedFacets[key].value.min : null}
                                                    onChange={(e) => this.onSelectionsChange(e.target.value, key, null, "min")}
                                                />
                                            </div>
                                            <div style={{maxWidth:80, marginLeft:10}}>
                                                <input
                                                    aria-label="Max"
                                                    className="form-control"
                                                    type="number"
                                                    min="0"
                                                    placeholder="Max"
                                                    value={selectedFacets[key] && selectedFacets[key].value ? selectedFacets[key].value.max : null}
                                                    onChange={(e) => this.onSelectionsChange(e.target.value, key, null, "max")}
                                                />
                                            </div>
                                            <div className="" style={{marginLeft:10}}>
                                                <button className="btn btn-dark" onClick={() => this.props.search(this.state.selectedFacets)}>
                                                    Go
                                                </button>
                                            </div>
                                        </div>
                                        :
                                <OverlayTrigger
                                    trigger="click"
                                    rootClose
                                    placement={'bottom'}
                                    overlay={
                                        <Popover id={key} style={{ width: 250, maxWidth: 250 }}>
                                            <Popover.Content className='popover-facet-body'>
                                                <React.Fragment>
                                                    <div className="">
                                                        {this.getPacehoder(key) &&
                                                            <div class="form-group has-feedback">
                                                                <input
                                                                    aria-label="Search"
                                                                    type="text"
                                                                    id="search"
                                                                    className="form-control"
                                                                    style="height:auto"
                                                                    placeholder={this.getPacehoder(key)}
                                                                    value={searchFacet[key]}
                                                                    onChange={(e) => this.setSearchFacet(e.target.value, key)}
                                                                />
                                                                <span className="fa fa-search"></span>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="">
                                                        {
                                                            (searchFacet[key] ? facetData[key].filter(x => x.value && x.value.includes(searchFacet[key])) : facetData[key]).map(item => {
                                                                return (
                                                                    <div key={item.value} className="c-control c-checkbox">
                                                                        <label>
                                                                            <input aria-label={item.value + item.count} className="c-control-input" type="checkbox" value={item.value}
                                                                                onChange={(e) => this.onSelectionsChange(e.target.checked, key, item.value)}
                                                                                checked={Array.isArray(selectedFacets[key]) && selectedFacets[key].find(x => x == item.value) ? true : false} />
                                                                            <i className="c-control-indicator fa fa-square-o"></i>
                                                                            <span className="c-control-description">{item.value}{' (' + item.count + ')'}</span>
                                                                        </label>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </React.Fragment>

                                            </Popover.Content>
                                        </Popover>
                                    }
                                >
                                    <div className="facetsDropdown d-flex justify-content-lg-between"><span>{this.getTitle(key)}</span><i className="fa fa-angle-down ml-2"></i></div>
                                </OverlayTrigger>
                                
                            )
                        })
                        }
                    </div>
                    :
                    keys.map(key => {
                        return (

                            <div id={key} className="card border-left-0 border-right-0 border-top-0 bg-transparent">
                                <div onClick={() => this.toggle(key)} className="card-header d-flex align-items-center">
                                    <div className="pr-2 mb-0">
                                        <span className="d-flex align-items-center">
                                            <span>{this.getTitle(key)}</span>
                                        </span>
                                    </div>
                                    {this.state.hide[key] ?
                                        <span className="ml-auto" >
                                            <i className="fa fa-angle-down" aria-hidden="true"></i>
                                        </span>
                                        :
                                        <span className="ml-auto">
                                            <i className="fa fa-angle-up" aria-hidden="true"></i>
                                        </span>
                                    }
                                </div>
                                <div style={{ 'background': 'a', 'overflow': 'auto', 'maxHeight': "250px" }} className={'card-body pb-0 ' + (this.state.hide[key] ? 'd-none' : '')}>
                                    {
                                        this.facetOperator(key) == 'range' ?
                                            <div className="row mb-3">
                                                <div className="col-4 pr-0">
                                                    <label htmlFor="min">
                                                        Min
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        aria-label="Min"
                                                        type="number"
                                                        min="0"
                                                        placeholder="Min"
                                                        value={selectedFacets[key] && selectedFacets[key].value ? selectedFacets[key].value.min : null}
                                                        onChange={(e) => this.onSelectionsChange(e.target.value, key, null, "min")}
                                                    />
                                                </div>
                                                <div className="col-4 pr-0">
                                                    <label htmlFor="max">
                                                        Max
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        aria-label="Max"
                                                        type="number"
                                                        min="0"
                                                        placeholder="Max"
                                                        value={selectedFacets[key] && selectedFacets[key].value ? selectedFacets[key].value.max : null}
                                                        onChange={(e) => this.onSelectionsChange(e.target.value, key, null, "max")}
                                                    />
                                                </div>
                                                <div className="col-auto align-self-end">
                                                    <button className="btn btn-dark" onClick={() => this.props.search(this.state.selectedFacets)}>
                                                        Go
                                                    </button>
                                                </div>
                                            </div>
                                            :
                                            <>
                                                <div className="">
                                                    {this.getPacehoder(key) &&
                                                        <div class="form-group has-feedback">
                                                            <input
                                                                type="text"
                                                                id="search"
                                                                aria-label="Search"
                                                                className="form-control"
                                                                style="height:auto"
                                                                placeholder={this.getPacehoder(key)}
                                                                value={searchFacet[key]}
                                                                onChange={(e) => this.setSearchFacet(e.target.value, key)}
                                                            />
                                                            <span className="fa fa-search"></span>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="">
                                                    {
                                                        (searchFacet[key] ? facetData[key].filter(x => x.value && x.value.includes(searchFacet[key])) : facetData[key]).map(item => {
                                                            return (
                                                                <div key={item.value} className="c-control c-checkbox">
                                                                    <label>
                                                                        <input aria-label={item.value + item.count} className="c-control-input" type="checkbox" value={item.value}
                                                                            onChange={(e) => this.onSelectionsChange(e.target.checked, key, item.value)}
                                                                            checked={Array.isArray(selectedFacets[key]) && selectedFacets[key].find(x => x == item.value) ? true : false} />
                                                                        <i className="c-control-indicator fa fa-square-o"></i>
                                                                        <span className="c-control-description">{item.value}{' (' + item.count + ')'}</span>
                                                                    </label>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </>
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

export default connect(
    mapStateToProps, bindAction
)(Facet);